/* eslint-disable jsx-a11y/no-onchange */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { Dropdown } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import styles from './select.module.scss';
import { handleCalculation } from '../../../modules/forms/utils/helpers';
import FormDataSourceDetails from '../../../components/customFields/FormDataSourceDetails';


class Select extends Component {
  constructor(props) {
    super(props);
      this.state = {
        dataSourceValueState: []
      };
    const { isRequired, updateFieldErrors, answer, default_value, fieldId } = this.props;

    if (isRequired && (answer === '' || answer === undefined || !answer)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
    if (default_value?.key && (answer === undefined || answer === null || answer === '')) {
      this.handleAnswerChanged(default_value?.key, fieldId);
    }
  }

  componentDidMount() {
    const { dataSourceValues } = this.props;
    const { dataSourceValueState } = this.state;
    if (dataSourceValues && dataSourceValues?.length > 0 && dataSourceValueState?.length === 0) {
      this.handleDataSource();
    }
  }

  componentDidUpdate() {
    const { dataSourceValues } = this.props;
    const { dataSourceValueState } = this.state;

    if (dataSourceValues && (dataSourceValues?.length>0) && dataSourceValueState?.length ===0) {
      this.handleDataSource();
    }
  }

  getSelectedValue = (answer, dropdownValues, isMulti) => {
    if (isMulti) {
      return dropdownValues
        ?.filter(e => answer && Array.isArray(answer) && answer?.some(a => e?.value === a?.value))
        ?.map(ele => ({
          key: ele?.key,
          label: ele?.value,
          value: ele?.value,
          detailKey: ele?.detailKey
        }));
    }
    return answer?.value ? { label: answer.value, value: answer.value } : null;
  };

  formatOptions = dropdownValues => dropdownValues?.map(ele => ({
    key: ele?.key,
    label: ele?.value,
    value: ele?.value,
    detailKey: ele?.detailKey
  })) ?? [];

  handleDataSource = () => {
    const { dataSourceValues } = this.props;
    this.setState({ dataSourceValueState: dataSourceValues });
  }

  handleCalValues = async () => {
    const { fields, answers, fromMultiGrid, allFields, handleValueChange, multiFieldId, formEntryFields } = this.props;
    let result;
    if (fromMultiGrid) {
      result = await handleCalculation(fields, answers, fromMultiGrid, allFields, multiFieldId);
    } else {
      result = await handleCalculation(formEntryFields, answers);
    }
    await result.reduce(async (promise, val) => {
      await promise;
      if (!val?.id) return;
      handleValueChange(val?.value, val.id);
    }, Promise.resolve());
  }

  handleSelectChange = (e, fieldId, isMulti) => {
    if (isMulti) {
      this.handleMultiAnswerChanged(e?.map(i => i.value) ?? [], fieldId, e);
    } else {
      this.handleAnswerChanged(e?.value, fieldId, e);
    }
  };

  handleDependencyFields = () => {
    const { formEntryFields, fieldId, handleValueChange, handleFieldErrorChanged } = this.props;
    if (formEntryFields?.length > 0) {
      formEntryFields.forEach((field) => {
        if (field?.type === 'number'
          && field?.settings?.form_count
          && Object.values(field?.settings?.count_map_fields || {})?.filter(f => f?.id === fieldId)?.length > 0
        ) {
          handleValueChange(undefined, field?.id);
          handleFieldErrorChanged(field?.id, true);
        }
      });
    }
  }


  handleAnswerChanged(value, fieldId, selectedVal) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, values = [], updateFieldErrors,
      widget: { type: widget }, fieldType, dataSourceID, allFields
    } = this.props;
    const { dataSourceValueState } = this.state;
    if (dataSourceID === 'ds6') {
      handleValueChange(
        { value, detailId: selectedVal?.detailKey },
        fieldId
      );
      const fullEntry = dataSourceValueState?.find(e => e?.key === selectedVal?.detailKey);
      const entryData = selectedVal?.data || fullEntry?.data;
      if (entryData && Object.keys(entryData).length > 0) {
        const copyFields = allFields?.filter(f => f?.settings?.copyField
          && f?.settings?.selectedCopyField?.startsWith(`ds6_${fieldId}_field_`)) || [];
        copyFields.forEach((field) => {
          const actualFieldId = field?.settings?.selectedCopyField?.replace(`ds6_${fieldId}_field_`, '');
          const ans = entryData?.[actualFieldId];
          if (ans !== undefined) {
            handleValueChange(ans, field.id);
            handleFieldErrorChanged(field.id, !(ans && ans !== ''));
          }
        });
      }
    } else {
      handleValueChange(value, fieldId);
    }
    let updatedErrors = [];
    if (value === '' || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else {
      let validOption = Object.keys(values).some(
        k => (String(values[k].key) === value || values[k].key === value)
      );
      if (dataSourceID === 'ds6') {
        validOption = Object.keys(values).some(k => values[k].value === value);
      }
      if (widget === 'portal_user') {
        validOption = values?.some(eachVal => value.some(selectOption => selectOption.key === eachVal.key));
      }
      if (widget === 'singleSearch') {
        validOption = true;
      }
      if (widget === 'user_dropdown' || fieldType === 'user_dropdown') {
        validOption = true;
      }
      handleFieldErrorChanged(fieldId, !validOption);
      if (!validOption) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.select.invalid_option'
        ];
      }
    }
    this.handleDependencyFields();
    updateFieldErrors(updatedErrors);
  }

  handleMultiAnswerChanged(value, fieldId, selected) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, values, updateFieldErrors,
      createdFormAnswer, dataSourceID, fields
    } = this.props;
    const { dataSourceValueState } = this.state;
    if (dataSourceID === 'ds6') {
      let dropdownValues = dataSourceValueState?.length > 0 ? dataSourceValueState?.map(val => ({
        key: val?.name,
        value: val?.name,
        label: val?.name,
        text: val?.name,
        detailKey: val?.key,
        detailId: val?.id
      })) : [];
      let result = [];
      if (selected !== undefined) {
        result = selected;
      } else {
        result = dropdownValues?.filter(item => value.includes(item.key));
      }
      let finalValues = result?.map(e => ({ value: e?.value, detailId: e?.detailKey }));
      let matchingField = null;
      if (fields?.length>0 && createdFormAnswer && Object.keys(createdFormAnswer)?.length>0) {
        matchingField = fields.find(ele => ele?.filters?.id === createdFormAnswer?.form_parent);
      }
      // If a matching field is found, execute handleValueChange
      if (matchingField && Object.keys(matchingField)?.length>0) {
        const fieldIdValue = matchingField.id;
        handleValueChange(finalValues, fieldIdValue);
      } else {
        handleValueChange(
          finalValues,
          fieldId
        );
      }
    }
    let updatedErrors = [];
    if ((Array.isArray(value) && value.length === 0) || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else {
      const validOption = value.every(ele => Object.keys(
          values
        ).some(
          k => (values[k]?.value === ele)
        ));
      handleFieldErrorChanged(fieldId, !validOption);
      if (!validOption) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.select.invalid_option'
        ];
      }
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { widget: { type: widget }, fieldId, isHideCompanyName, answer, values, defaultOption, disabled, tenantName, Badging, fullWidth,
      StylesClasses, placeholder, selected_users, fieldType, dataSourceID,
      filters, settings, formEntryAnswer } = this.props;
    // debugger;
    let fieldWidget;
    const { dataSourceValueState } = this.state;
    let dropdownValues = values;
    if (dataSourceID === 'ds6') {
      dropdownValues = dataSourceValueState?.length > 0 ? dataSourceValueState?.map(val => ({
        key: val?.name,
        value: val?.name,
        label: val?.name,
        text: val?.name,
        detailKey: val?.key,
        detailId: val?.id
      })) : [];
    }

    if (widget === 'dropdown' && dataSourceID !== 'ds6') {
      if (Badging && fieldId === 'employer') {
        fieldWidget = (
          <select
            value={answer}
            onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
            name={`select-field-${fieldId}`}
            className={styles.select}
            disabled={disabled}
          >
            <option key={tenantName[0]?.id} value={tenantName[0]?.id}>{tenantName[0]?.name}</option>
          </select>
        );
      } else {
        fieldWidget = (
          <select
            value={answer}
            onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
            onBlur={this.handleCalValues}
            name={`select-field-${fieldId}`}
            className={styles.select}
            disabled={disabled}
            title={values?.[answer]?.value || ''}
          >
            <option key="default" value="">{defaultOption}</option>
            {values?.map(option => ((option?.favourite === true)&&(
              <option key={option.key} value={option.key} title={option.value}>
                {option?.value?.length > 40 ? `${option.value.substring(0, 40)}...` : option.value}
              </option>
            )))}
            {values?.some(option => (option?.favourite))
            && <option disabled className={styles.dividerOption} />
            }
            {values?.map(option => ((option.favourite !== true)&&(
              <option key={option.id} value={option.key} title={option.value}>
                {fullWidth && (option?.value?.length > 107 ? `${option.value.substring(0, 107)}...` : option.value)}
                 {!fullWidth && (option?.value?.length > 40 ? `${option.value.substring(0, 40)}...` : option.value)}
              </option>
            )))}
          </select>
        );
      }
    } else if (widget === 'dropdown' && dataSourceID === 'ds6') {
      const isMultiMode = settings?.enable_multi_select_for_this_data_source_field;
        fieldWidget = (
              <div style={{ width: '330px' }}>
                <ReactSelect
                  isMulti={isMultiMode}
                  value={this.getSelectedValue(answer, dropdownValues, isMultiMode)}
                  onChange={e => this.handleSelectChange(e, fieldId, isMultiMode)}
                  options={this.formatOptions(dropdownValues)}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                  menuPortalTarget={document.body}
                  isDisabled={disabled || settings?.data_source_interaction_type?.value === 'createNewEntry'}
                  className={`react-select-custom ${StylesClasses ?? ''}`}
                  classNamePrefix="custom"
                  placeholder={!isMultiMode ? placeholder : undefined}
                />
              </div>
        );
    } else if (widget === 'multiSearch') {
      fieldWidget = (
        <Select
          isMulti
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          options={values}
        />
      );
    } else if (widget === 'singleSearch') {
      fieldWidget = (
        <Dropdown
          selection
          search
          scrolling
          clearable
          value={answer}
          options={[
            { key: '', value: '', text: '' },
            ...values
          ]}
          onChange={(e, val) => this.handleAnswerChanged(val.value, fieldId)}
          className={`${StylesClasses}`}
        />
      );
    } else if (widget === 'portal_user') {
      fieldWidget = (
        <ReactSelect
          isMulti
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          name={`select-field-${fieldId}`}
          className={`${StylesClasses}`}
          options={values?.map(user => ({
             label: isHideCompanyName ? user.value : `${user.tenantName?.join(', ')} - ${user.value}`,
             key: user.key,
             value: user.value
          }))?.sort((a, b) => a.label.localeCompare(b.label))}
        />
      );
    } else if (widget === 'user_dropdown' || fieldType === 'user_dropdown') {
      fieldWidget = (
        <ReactSelect
          isMulti
          value={answer}
          onChange={e => this.handleAnswerChanged(e, fieldId)}
          name={`select-field-${fieldId}`}
          className={`${StylesClasses}`}
          placeholder={placeholder}
          options={selected_users?.map(user => ({ label: user.value, key: user.key, value: user.value }))}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 99999 })
          }}
          menuPortalTarget={document.body}
        />
      );
    } else {
      fieldWidget = (
        <div className={styles.pulpoRadio}>
          {values?.map(option => (
            <label key={option.key}>
              <input
                type="radio"
                className="pulpo-radio"
                value={option.key}
                onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
                checked={answer === option.key}
                disabled={disabled}
              />
              {option.value}
            </label>
          ))}
        </div>
      );
    }

    let formDetailID;
    if (formEntryAnswer?.key) {
      formDetailID = formEntryAnswer.key;
    } else if (settings?.enable_multi_select_for_this_data_source_field) {
      formDetailID = answer;
    } else {
      formDetailID = answer?.detailId;
    }
    return (
      <>
      {fieldWidget}
      {dataSourceID === 'ds6' && (
        <FormDataSourceDetails
          link
          search={filters?.show_values?.value === 'table'}
          showInLineTable={settings?.show_values_in_inline_table_view}
          FormDetailID={formDetailID}
          fieldId={fieldId}
          filters={filters}
          dataSourceID={dataSourceID}
          settings={settings}
          dataSourceValueState={dataSourceValueState}
          handleAnswerForTableSelect={this.handleSelectChange}
          handleMultiAnswerForTableSelect={this.handleMultiAnswerChanged}
          answer={answer}
        />
      )}
      </>
    );
  }
}

Select.defaultProps = {
  widget: { type: 'dropdown' },
  answer: '',
  defaultOption: ''
};

Select.propTypes = {
  widget: PropTypes.shape({ type: PropTypes.string }),
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired,
  defaultOption: PropTypes.string
};

export default Select;
